var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.onlyDaysLeft ? _c('span', _vm._b({}, 'span', _vm.$attrs, false), [_vm._v(_vm._s(_vm.daysLeft) + " ")]) : _c('span', {
    staticClass: "page-text--sm grey-6--text line-height-15"
  }, [_vm._v(" " + _vm._s(_vm.startsAt) + " ~ " + _vm._s(_vm.endsAt) + " " + _vm._s(_vm.daysLeft) + " ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }